import produce from 'immer';
import { apiRequest } from '../api/ApiRequest';

const UPDATE_CALCULATION_SETTING = 'calculator/UPDATE_CALCULATION_SETTING';
const UPDATE_CALCULATION_RESULT = 'calculator/UPDATE_CALCULATION_RESULT';
const UPDATE_ALLCLAIMSINSYSTEM = 'calculator/UPDATE_ALLCLAIMSINSYSTEM';
const UPDATE_PACKAGE_FROM_FILE = 'calculator/UPDATE_PACKAGE_FROM_FILE';
const UPDATE_FILE_NAME = 'calculator/UPDATE_FILE_NAME';

const UPDATE_UNITTEST_RESULT = 'calculator/UPDATE_UNITTEST_RESULT';



const SET_CASE_CALCULATE_DATES = 'calculator/SET_CASE_CALCULATE_DATES';


const BASE_URL = process.env.REACT_APP_ILWEB_API_URL + '/claim';
// const BASE_CLAIM_URL = process.env.REACT_APP_ILWEB_API_URL + '/claim';

const initialState = {
  isPackageLoaded : false,
  isCalculated : false,
  claimSetting: {},
  claimResult: {},
  packageFileName : null,
  claimInSystemList : [],
  oldestDueDate : new Date(),
  unitTest : null
};


const getRowColor = (item) => {
  switch(item.itemType){
    case 1: //Höfuðstóll
      return "highlight-calc-capital";
    case 2: //Samningsvextir
      return "highlight-calc-contractinterest";
    case 3: //Dráttavextir
      return "highlight-calc-penaltyinterest";
    case 4: //Vaskur
      return "highlight-calc-vat";
    case 5: //Fjármagnstekjuskattur
      return "highlight-calc-capitalgainstax";
    case 6: //Höfuðstólsfæra
      return "highlight-calc-capitalizeinterests";
    case 7: //Innheimtulaun
      return "highlight-calc-collectionfee";
    case 8: //Kostnaður
      return "highlight-calc-cost";
    case 9: //Innborgun
      return "highlight-calc-payment";
    case 10: //FTS til greiðslu.
      return "highlight-calc-paidcapitalgainstax";
    case 12: //Vísitala
      return "highlight-calc-index";
    case 11: //Summary
      return "highlight-calc-middlesummary";
    case 13: //Summary
      return "highlight-calc-totalsummary";
  }
  return "highlight-calc-unknown";
};

const getColor = (transactionNumber) =>  {
  let start   = 10000001;
  start = start - (100000 * Number(transactionNumber));
  let color = '#' + start.toString(16);
  return color;
};

const findKey = (transactionKey, transactionKeyTable) => {
  for (let i = 0; i < transactionKeyTable.length; i++) {
    if (transactionKeyTable[i].key === transactionKey){
      return transactionKeyTable[i];
    }
  }
  return null;
};

const postProcessResult = (calculationResult, setting) => {

  let startTime = new Date();

  for (let p = 0; p < calculationResult.payments.length; p++) {
    let payment = calculationResult.payments[p];
    payment.total = payment.amount + payment.lawyerAmount;
  }

  for(let j = 0; j < calculationResult.creditorLines.length; j++)
  {
    let line = calculationResult.creditorLines[j];
    //Prepare the line.
    line.rowDetail = {
      rowColor : getRowColor(line),
      boxColor :  getColor(line.transactionNumber),
    };
    if ([1,7,8,9].indexOf(line.itemType) > -1) {
      line.transactionKeyDetail = findKey(line.transactionKey, setting.transactionKeyTable);
    }

    //Prepare the payment boxes.
    for (let i = 0; i < line.paymentLines.length; i++) {
      let paymentLine = line.paymentLines[i];
      paymentLine.tagDetail = {
        text : paymentLine.paymentOrder.toString(),
        color : getColor(paymentLine.transactionNumber)
        //toolTip :  vm.$filter('number')(paymentLine.amount,2)
      };
    }
  }

  // console.debug("Process lawyerLines");
  for(let j = 0; j < calculationResult.lawyerLines.length; j++) {
    let line = calculationResult.lawyerLines[j];

    //Prepare the line.
    line.rowDetail = {
      rowColor : getRowColor(line),
      boxColor :  getColor(line.transactionNumber),
    };

    if ([1,7,8,9].indexOf(line.itemType) > -1){
      line.transactionKeyDetail = findKey(line.transactionKey, setting.transactionKeyTable);
    }

    //Prepare the payment boxes.
    for (let i = 0; i < line.paymentLines.length; i++) {
      let paymentLine = line.paymentLines[i];
      paymentLine.tagDetail = {
        text : paymentLine.paymentOrder.toString(),
        color : getColor(paymentLine.transactionNumber)
        // toolTip : vm.$filter('number')(paymentLine.amount,2)
      };
    }

  }

  let endTime = new Date();
  let timeDiff = endTime - startTime;
  let ms = Math.round(timeDiff);
  console.debug("process tok: ", ms + " ms");
  return calculationResult;
};



export const loadCalculationSetting = claimID => async dispatch => {
  const data = await apiRequest(`${BASE_URL}/calculate/package/${claimID}`);
  if (!data.error) {
    console.debug("loadCalculationSetting", BASE_URL ,claimID, data);
    dispatch({
      type: UPDATE_CALCULATION_SETTING,
      data: data || {}
    });
  }
  return data;
};


export const loadCalculationSetting2 = settings => async dispatch => {
  console.debug("setting", settings);
  dispatch({
    type: UPDATE_CALCULATION_SETTING,
    data: settings || {}
  });
  return settings;
};


export const loadCalculationResult = settings => async dispatch => {    
  const data = await apiRequest(`${BASE_URL}/calculate/package`,{data: settings, contentType: 'application/json', method: 'post'});
  if (!data.error) {
    console.log("loadCalculationResult", BASE_URL , settings, data);
    dispatch({
      type: UPDATE_CALCULATION_RESULT,
      data: postProcessResult(data.result, data.setting) || {}
    });
  }
  return data;
};


export const loadUnitTest = settings => async dispatch => {  
  const data = await apiRequest(`${BASE_URL}/calculate/unittest`,
  {data: settings, 
    method: 'post'});
    //  responseType : 'text/plain'});
 // console.debug("Test", data);
  if (!data.error) {    
    dispatch({
      type: UPDATE_UNITTEST_RESULT,
      data: data || null
    });
  }
  return data;
};


export const loadClaimInSystemList = () => async dispatch => {
   const data = await apiRequest(`${BASE_URL}/list/claim`);
  if (!data.error) {
    dispatch({
      type: UPDATE_ALLCLAIMSINSYSTEM,
      data: data || []
    });
  }
  return data;
};

export const updatePackgeFileName = filename => async dispatch => {
  console.debug("filename", filename);
  dispatch({
    type: UPDATE_FILE_NAME,
    data: filename || undefined
  });
  return filename;
};

export const loadPackageFromFile = file => async dispatch =>{
  let dataForm = new FormData();
  dataForm.append('file', file);
  dataForm.append('name', file.name);
  const data = await apiRequest(`${BASE_URL}/calculate/package/upload`,{data: dataForm, contentType: 'multipart/form-data', method: 'post'});
  if (!data.error) {
    console.debug("loadPackageFromFile", file, data);
    dispatch({
      type: UPDATE_CALCULATION_SETTING,
      data: data || {}
    });
  }
  return data;
};

export const setCaseCalculationInformation = (calculateTo, principalTo, calledIn, calledInBecauseOfDefaultDebt) => async dispatch => {
  let data = {
    calculateTo : calculateTo,
    principalTo : principalTo,
    calledIn : calledIn,
    calledInBecauseOfDefault : calledInBecauseOfDefaultDebt};
  dispatch({
    type: SET_CASE_CALCULATE_DATES,
    data: data
  });
  return data;
};

const FindOldestDueDate = (data) =>{  
 // console.debug("FIND OLDEST DUEDATE", data);
  let oldest = data.collectionStart;
  if (data.isBond){
    oldest = data.bond.legs[0].issueDate;
  }
  else
  {
    if ((data.principals != null) && (data.principals.length > 0)){
      for (let i = 0; i < data.principals.length; i++) {
        let record = data.principals[i];
        if (record.dueDate < oldest){
          oldest = record.dueDate;
        }
      }
    }
  }
 // console.debug("->", oldest);
  return oldest;
}


const calculatorReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case UPDATE_CALCULATION_SETTING:
        console.log("Setting", action.data);
        draft.oldestDueDate = FindOldestDueDate(action.data);
        draft.isPackageLoaded = true;
        draft.claimResult = {};
        draft.claimSetting = action.data;
        draft.isCalculated = false;
        //draft.claimSetting.principalsTo = action.data.calculateTo;
        if (action.data.isBond){
          if (action.data.bond.legs[0].calledIn){
           // console.debug("Gjaldfellt, á að breyta um dag í principal og hak")
            draft.claimSetting.principalsTo = action.data.bond.legs[0].calledInDate;
          }
        }
       // console.debug("REDUX, setting", draft.claimSetting);
        break;
      case UPDATE_UNITTEST_RESULT:
        draft.unitTest = action.data;
        break;
      case UPDATE_CALCULATION_RESULT:        
        draft.claimResult = action.data;
        draft.isCalculated = true;
      //  console.debug("Lines", action.data.creditorLines.length);
        break;
      case UPDATE_FILE_NAME:
        draft.packageFileName = action.data;
        break;
      case UPDATE_ALLCLAIMSINSYSTEM:
        draft.claimInSystemList = action.data;
        break;
      case SET_CASE_CALCULATE_DATES:
        draft.claimSetting.calculateTo = action.data.calculateTo;
        draft.claimSetting.principalsTo = action.data.principalTo;
        if (draft.claimSetting.isBond){
          if (action.data.calledIn) {
            draft.claimSetting.bond.legs[0].calledIn = true;
            draft.claimSetting.bond.legs[0].calledInDate = action.data.principalTo;
            draft.claimSetting.bond.legs[0].calledInBecauseOfDefault = action.data.calledInBecauseOfDefault;
          }
          else {
            draft.claimSetting.bond.legs[0].calledIn = false;
            draft.claimSetting.bond.legs[0].calledInBecauseOfDefault = false;
          }
        }
        break;
      default:
        break;
    }
  });


export default calculatorReducer;



// WEBPACK FOOTER //
// ./src/ducks/calculator.js